import { useState } from 'react';
import { useIntl } from 'react-intl';
import { Dialog, DialogHeader } from '@astryxdesign/core/Dialog';
import { Layout, LayoutContent, LayoutFooter } from '@astryxdesign/core/Layout';
import { Button } from '@astryxdesign/core/Button';
import { CheckboxInput } from '@astryxdesign/core/CheckboxInput';
import { HStack } from '@astryxdesign/core/HStack';
import { Text } from '@astryxdesign/core/Text';
import { VStack } from '@astryxdesign/core/VStack';
import { useTelegramActions, useTelegramStatus } from '../../api/telegram';
import { TelegramWizard } from './TelegramWizard';

export function TelegramPrompt() {
  const intl = useIntl();
  const status = useTelegramStatus();
  const actions = useTelegramActions();
  const [never, setNever] = useState(false);
  const [answered, setAnswered] = useState(false);
  const [wizard, setWizard] = useState(false);

  const answer = (action: 'skip' | 'configure') => {
    setAnswered(true);
    actions.prompt.mutate({ action, never });
    if (action === 'configure') setWizard(true);
  };

  if (wizard) return <TelegramWizard start="events" onClose={() => setWizard(false)} />;
  if (answered || !status.data?.prompt) return null;
  const close = (open: boolean) => {
    if (!open) answer('skip');
  };
  return (
    <Dialog isOpen onOpenChange={close} width={480}>
      <Layout
        header={
          <DialogHeader
            title={intl.formatMessage({ id: 'notifications.prompt.title' })}
            onOpenChange={close}
          />
        }
        content={
          <LayoutContent>
            <VStack gap={3}>
              <Text>{intl.formatMessage({ id: 'notifications.prompt.text' })}</Text>
              <Text color="secondary">{intl.formatMessage({ id: 'notifications.prompt.examples' })}</Text>
            </VStack>
          </LayoutContent>
        }
        footer={
          <LayoutFooter>
            <VStack gap={3}>
              <HStack gap={2} hAlign="end">
                <Button
                  label={intl.formatMessage({ id: 'notifications.prompt.skip' })}
                  variant="ghost"
                  onClick={() => answer('skip')}
                />
                <Button
                  label={intl.formatMessage({ id: 'notifications.prompt.configure' })}
                  variant="primary"
                  onClick={() => answer('configure')}
                />
              </HStack>
              <CheckboxInput
                label={intl.formatMessage({ id: 'notifications.prompt.never' })}
                value={never}
                onChange={(v: boolean) => setNever(v)}
              />
            </VStack>
          </LayoutFooter>
        }
      />
    </Dialog>
  );
}
